export default __webpack_public_path__ + "static/media/desktop.bbd48354.svg";